<template>
    <div>
        <div class="card" v-if="compact">
            <img :src="thintheme" class="card-img-top compact">

            <div class="card-body pt-3 pb-3">
                <div class="row align-items-center">
                    <div class="col-auto">
                        <a href="#" class="avatar avatar-xl rounded-circle">
                            <img :src="user.avatar" class="rounded-circle">
                        </a>
                    </div>
                    <div class="col ml--2">

                        <h4>{{ user.name }}</h4>
                        <div class="h5 font-weight-300">
                            <span v-if="user.owner">{{ user.owner.name }}</span>
                            <span v-if="user.entity"> / {{ user.entity.name }}</span>
                        </div>
                    </div>
                    <div class="col-auto">
                        <div class="h5 mb-0" v-if="cohort">
                            <a href="#" @click.prevent="$emit('openCohort')" v-if="$permissions.hasRight('dashboard.learners.read')">
                                <i class="fas fa-users mr-1"></i> {{ cohort.name }}
                            </a>
                            <span v-else>
                                <i class="fas fa-users mr-1"></i> {{ cohort.name }}
                            </span>
                        </div>

                        <div class="h5 mt-3 mb-0" v-if="groups && groups.length">
                            <a href="#" @click.prevent="$emit('openGroup')" v-if="$permissions.hasRight('dashboard.learners.read')">
                                <i class="fas fa-user-friends mr-1"></i> {{ groups[0].name }}
                            </a>
                            <span v-else>
                                <i class="fas fa-user-friends mr-1"></i> {{ groups[0].name }}
                            </span>
                        </div>

                        <div class="h5 mb-0" v-if="showEmail">
                            <a :href="'mailto:'+user.email">
                                <i class="fas fa-envelope mr-1"></i> {{ user.email }}
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="card card-profile" v-else>
            <img :src="theme" class="card-img-top">

            <div class="row justify-content-center">
                <div class="col-lg-3 order-lg-2">
                    <div class="card-profile-image">
                        <img :src="user.avatar" class="rounded-circle">
                    </div>
                </div>
            </div>

            <!-- spacer -->
            <div class="card-header text-center border-0 pt-5 pb-4">
            </div>

            <div class="card-body pt-0">

                <div class="text-center">

                    <h5 class="h3">
                        {{ user.name }}
                    </h5>

                    <div class="h5 font-weight-300">
                        <span v-if="user.owner">{{ user.owner.name }}</span>
                        <span v-if="user.entity"> / {{ user.entity.name }}</span>
                    </div>

                    <div class="h5 mt-4" v-if="cohort">
                        <a href="#" @click.prevent="$emit('openCohort')" v-if="$permissions.hasRight('dashboard.learners.read')">
                            <i class="fas fa-users mr-1"></i> {{ cohort.name }}
                        </a>
                        <span v-else>
                            <i class="fas fa-users mr-1"></i> {{ cohort.name }}
                        </span>
                    </div>

                    <div class="h5 mt-3" v-if="groups && groups.length">
                        <a href="#" @click.prevent="$emit('openGroup')" v-if="$permissions.hasRight('dashboard.learners.read')">
                            <i class="fas fa-user-friends mr-1"></i> {{ groups[0].name }}
                        </a>
                        <span v-else>
                            <i class="fas fa-user-friends mr-1"></i> {{ groups[0].name }}
                        </span>
                    </div>

                    <div class="h5 mt-4" v-if="showEmail">
                        <a :href="'mailto:'+user.email">
                            <i class="fas fa-envelope mr-1"></i> {{ user.email }}
                        </a>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {

        props: {

            user: {
                type: Object,
                required: true
            },

            showEmail: {
                type: Boolean,
                default: false
            },

            cohort: {
                type: Object,
                default: null
            },

            groups: {
                type: Array,
                default: null
            },

            compact: {
                type: Boolean,
                default: false
            },
        },

        data() {
            return {
                theme: this.$baseURL + '/img/theme.jpg',
                thintheme: this.$baseURL + '/img/thintheme.jpg',
            }
        }
    }
</script>

<style scoped>

    .card-profile img {
        max-height: 150px;
    }
    .card-profile img.compact {
        max-height: 20px;
    }

</style>

